import { ILoyaltyDetails } from '../../../../../../account/domain/models/ILoyaltyDetails';
import { trackPurchase } from '../../../../../../shared/analytics/e-commerce/trackPurchase';
import { NewBooking } from '../../../../../domain/booking/models/NewBooking';
import { adaptNewBookingToItems } from './adapters/adaptNewBookingToItems';

export function trackBookingComplete(
	booking: NewBooking,
	loyaltyDetails?: ILoyaltyDetails,
) {
	if (!booking.reference) {
		return;
	}

	const items = adaptNewBookingToItems(booking) ?? [];
	const { usedExistingVehicleFromAccount } = booking.vehicleDetails ?? {};

	trackPurchase({
		transactionId: booking.reference,
		entryDate: booking?.entryDate,
		exitDate: booking?.exitDate,
		totalPrice: booking.totalPrice,
		coupon: booking.promoCode,
		prefilledVehicle: usedExistingVehicleFromAccount,
		items,
		loyaltyTitle: loyaltyDetails?.tier,
		loyaltyPoints: loyaltyDetails?.redeemablePoints,
	});
}
